import React, { Fragment, forwardRef, useContext, useEffect, useState } from 'react';
import { HTML, YFMWrapper } from '../../../components/';
import { ThemeValueContext } from '../../../context/theme/ThemeValueContext';
import { Col, GridColumnSize } from '../../../grid';
import { block, getThemedValue } from '../../../utils';
import PreviewContent from './PreviewContent';
import PreviewMedia from './PreviewMedia';
import './MediaContent.css';
const b = block('preview-media-content-block');
const MediaContent = forwardRef((props, ref) => {
    const { items, title, description = '', switching, ratioMediaContent = '1-1', isActiveBlock, showMediaContent, } = props;
    const { themeValue: theme } = useContext(ThemeValueContext);
    const [mediaSizes, setMediaSizes] = useState({ [GridColumnSize.All]: 12 });
    const [contentSizes, setContentSizes] = useState({ [GridColumnSize.All]: 12 });
    useEffect(() => {
        const [mediaSize, contentSize] = ratioMediaContent.split('-');
        const blockSize = 12 / (Number(mediaSize) + Number(contentSize));
        const updatedMediaSizes = Object.assign(Object.assign({}, mediaSizes), { [GridColumnSize.Md]: blockSize * Number(mediaSize) });
        setMediaSizes(updatedMediaSizes);
        const updatedContentSizes = Object.assign(Object.assign({}, contentSizes), { [GridColumnSize.Md]: blockSize * Number(contentSize) });
        setContentSizes(updatedContentSizes);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ratioMediaContent]);
    const contentComponents = [];
    const mediaComponents = [];
    items.forEach((item, id) => {
        const { content, media } = item;
        const isActive = isActiveBlock(id);
        const contentMods = { active: isActive };
        const mediaMods = { active: isActiveBlock(id, true) };
        const onClick = () => showMediaContent(id);
        contentComponents.push(React.createElement(PreviewContent, Object.assign({ key: id, id: id }, content, { switching: switching, onClick: onClick, mods: contentMods })));
        mediaComponents.push(React.createElement(PreviewMedia, { key: id, id: id, media: media && getThemedValue(media, theme), play: isActive, mods: mediaMods }));
    });
    return (React.createElement(Fragment, null,
        React.createElement(Col, { sizes: contentSizes, className: b('content') },
            React.createElement("div", { className: b('header') },
                React.createElement("h2", { className: b('title') },
                    React.createElement(HTML, null, title)),
                description && (React.createElement("div", { className: b('description') },
                    React.createElement(YFMWrapper, { content: description, modifiers: { constructor: true } })))),
            React.createElement(Col, { ref: ref, className: b('menu') },
                React.createElement("div", { className: b('content-wrapper') }, contentComponents))),
        React.createElement(Col, { sizes: mediaSizes, className: b('media') }, mediaComponents)));
});
MediaContent.displayName = 'MediaContent';
export default MediaContent;
